import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import React, { useEffect } from "react";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicePage from "@/pages/ServicePage";
import OurWork from "@/pages/OurWork";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-ink flex items-center justify-center p-6">
          <div className="text-center">
            <p className="font-display text-3xl font-bold uppercase text-slate-100">Something went wrong</p>
            <p className="text-slate-400 mt-3">
              Please reload the page, or call us at (406) 291-6639.
            </p>
            <a
              href="/"
              data-testid="error-recover-link"
              className="inline-block mt-6 bg-gold px-6 py-3 text-sm font-bold uppercase tracking-wider text-ink hover:bg-gold-light transition-colors"
            >
              Back to Home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function NotFound() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 text-center">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold">404</p>
      <h1 className="font-display text-4xl font-bold uppercase text-slate-100 mt-3">Page not found</h1>
      <p className="text-slate-400 mt-3">That page doesn't exist. Try the menu above, or call us at (406) 291-6639.</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="inline-block mt-8 bg-gold px-6 py-3 text-sm font-bold uppercase tracking-wider text-ink hover:bg-gold-light transition-colors"
      >
        Back to Home
      </Link>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/commercial-welding" element={<ServicePage id="commercial" />} />
            <Route path="/agricultural-welding" element={<ServicePage id="agricultural" />} />
            <Route path="/residential-welding" element={<ServicePage id="residential" />} />
            <Route path="/welding-repairs" element={<ServicePage id="repairs" />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
